import styled, { css } from "styled-components/macro";
import { device } from "../../../device";

// Audiences
export const AudiencesContainer = styled.div`
  padding: 0px;
  margin: 24px 0;
  max-width: 650px;
`;
export const StatsTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;

  color: #575e68;

  margin: 14px 0;
  display: flex;
  gap: 1rem;
  @media ${device.mobileL} {
    font-size: 20px;
    line-height: 30px;
  }
  @media ${device.mobileS} {
    font-size: 18px;
    line-height: 26px;
  }

  a {
    display: inline-block;
    width: 24px;
    color: #575e68;
  }
`;
export const StatsTable = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(auto-fill, 3rem);

  padding: 0 1.5rem;

  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;
  margin: 1rem 0;
`;

export const StatsTableColHead = styled.li`
  display: flex;
  align-items: center;
  padding-right: 1rem;

  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #575e68;

  span {
    margin-right: 3px;
  }
`;

export const StatsTableCell = styled.li`
  font-size: 12px;
  line-height: 18px;
  text-transform: capitalize;
  color: #575e68;
  padding: 1rem 0;
  padding-right: 1rem;
  @media ${device.mobileS} {
    padding-right: 0.3rem;
  }
  border-top: 1px solid rgba(46, 46, 46, 0.1);

  ${"" /* status done or running */}
  & span {
    ${(props) =>
    props.status &&
    css`
        border-radius: 4px;
        color: #ffffff;
        padding: 4px 8px;
        @media ${device.mobileS} {
          font-size: 10px;
          line-height: 14px;
        }
        background: ${(props) => {
        switch (props.status) {
            case "Ready":
                return "#008060";
            case "Populating":
                return "#df8702";
            default:
                return "grey";
        }
    }};
      `}
  }
`;

// integrate Facebook message
export const IntegrateFMsgContainer = styled.div`
  padding: 24px;
  margin: 24px 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 30px;

  @media ${device.tablet} {
    flex-direction: column;
    gap: 0;
  }
`;
export const StyledSolvingProblemsIlustrationContainer = styled.div`
  padding: 14px;
`;

export const StyledInnerIntegrateFMsg = styled.div`
  text-align: left;
  ${"" /* margin: 14px 40px; */}
  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #575e68;
    margin: 14px 0;
    @media ${device.mobileL} {
      font-size: 22px;
      line-height: 34px;
      margin: 12px 0;
    }
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #575e68;
    margin: 14px 0;
    @media ${device.mobileL} {
      font-size: 14px;
      line-height: 22px;
      margin: 10px 0;
    }
  }
  button {
    padding: 10px 21px;
    background: #6270c6;
    border: 1px solid #939dd6;
    border-radius: 4px;

    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: #fcfcfd;
    &:hover {
      cursor: pointer;
    }
    @media ${device.mobileL} {
      font-size: 14px;
      line-height: 14px;
    }
  }
  a {
    display: inline-block;
    text-decoration: none;
    padding: 7px 21px;
    background: #6270c6;
    border: 1px solid #939dd6;
    border-radius: 4px;

    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: #fcfcfd;
    &:hover {
      cursor: pointer;
    }
    margin-top: 14px;
    @media ${device.mobileL} {
      font-size: 14px;
      line-height: 14px;
      margin-top: 12px;
    }
  }
`;